﻿import { CategorySpecificLiveData } from '../apiTypes/GameService';
import { QueryFunction, useQueries } from '@tanstack/react-query';
import { getSpecificLiveData } from '../api/CasinoApi';

export type CategoryLiveData = CategorySpecificLiveData & {
  categoryId: string
}

const useCategoryLiveData = (categorieIds: string[]) => {
  const dataQueries = useQueries({
    queries: categorieIds.length ? categorieIds.map((id) => ({
      queryKey: ['liveData', id],
      queryFn: (() => getSpecificLiveData(id)) as QueryFunction<CategorySpecificLiveData>,
      select: (data: CategorySpecificLiveData) => ({ ...data, categoryId: id })
    })) : []
  });

  const allLiveData: CategoryLiveData[] = [];
  for (const queryData of dataQueries) {

    if (!queryData.data || queryData.status === 'error') continue;

    allLiveData.push(queryData.data);
  }

  return allLiveData;
};

export default useCategoryLiveData;